import React from 'react'
import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'

function CeremonyVenue({ open, handleClose, handleNext, handleBack }) {
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>Do you have a Ceremony Venue selected yet?</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								<ButtonCustom
									variant="pilled"
									onClick={() => handleNext()}
								>
									Yes
								</ButtonCustom>
								<ButtonCustom
									variant="pilled"
									onClick={() => handleNext(2)}
								>
									Show me options
								</ButtonCustom>
								<ButtonCustom
									variant="pilled"
									onClick={() => handleNext(2)}
								>
									No
								</ButtonCustom>
							</div>
						</div>
					</div>
				</div>
				{/* <ButtonCustom size="lg" onClick={() => handleNext()}>Next</ButtonCustom> */}
				<div className={styles.buttonContainer}>
					<Stepper activeStep={1.99} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default CeremonyVenue
